/**
 * Created by minh on 27/6/2016.
 */

angular.module('taric.model.adcotype',['ngResource', 'common.helper']).factory('QueryAdditionalCodeType', function ($resource, CONSTANTS) {
    return $resource(CONSTANTS.host + CONSTANTS.ws_context + '/ref/adco/additionalCodeTypes', {}, {
        queryAdditionalCodeTypes : {
            method: 'GET',
            isArray: false
        }
    });
}).service('AdditionalCodeTypeModel', function($q, QueryAdditionalCodeType, CommonHelper){
    var model = this;
    model.queryAdditionalCodeTypes = function(meursingOnly){
        var deferred = $q.defer();
        QueryAdditionalCodeType.queryAdditionalCodeTypes({meursingOnly: meursingOnly}, function(additionalCodeTypes){
            deferred.resolve(additionalCodeTypes);
        }, function(error){
            deferred.reject(error);
        });
        return deferred.promise;
    };
});



// WEBPACK FOOTER //
// ./app/taric/adco/shared/adco-type-model.js